import { render, staticRenderFns } from "./PokDelivery.vue?vue&type=template&id=5407cd28"
import script from "./PokDelivery.vue?vue&type=script&lang=js"
export * from "./PokDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports